<div mat-dialog-title class="dialog-header d-flex justify-content-between">
  <div i18n="@@productDetails">Product Details</div>
  <mat-icon (click)="closeDialog()" class="cursor" i18n-aria-label="@@closeDialog" aria-label="Close">close</mat-icon>
</div>

<mat-dialog-content>
    <div class="cards-container">
        <mat-card class="icons-card mb-16">
            <mat-card-content>
                <mat-icon class="mr-10" color="accent" i18n-aria-label="@@membershipCard" aria-label="Membership card">card_membership</mat-icon>
                <div class="w-90">
                    <div class="mb-12 mat-caption" matTooltip ellipsisTooltip>{{product?.productName}}</div>
                    <div class="d-flex align-items-center mat-caption mb-10">
                        <mat-icon class="mr-10" i18n-aria-label="@@creationDateIcon" aria-label="Creation date">date_range</mat-icon>
                        <div class="mat-caption" matTooltip ellipsisTooltip>{{product?.creationDate}}</div>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
        <!-- <mat-expansion-panel class="mb-16">
            <mat-expansion-panel-header>
            <mat-panel-title i18n="@@departments">Departments</mat-panel-title>
            </mat-expansion-panel-header>
            <div *ngFor="let department of product?.departments;let index=index;" class="mat-caption mb-28" matTooltip ellipsisTooltip>{{department?.name}}</div>
        </mat-expansion-panel> -->
        <div class="d-flex">
            <button i18n="@@Reject" data-testid="Reject" class="w-50 mr-10" mat-raised-button color="primary" (click)="Reject()">Reject</button>
            <button i18n="@@Approve" data-testid="Approve" class="w-50" mat-raised-button color="primary" (click)="Approve()">Approve</button>
        </div>
    </div>
</mat-dialog-content>